import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useIntl} from "react-intl";
import DataItem from '../../../../../_common/components/DataItem';
import DataItemSelect from '../../../../../_common/components/DataItemSelect';
import DataItemSelectAsync from '../../../../../_common/components/DataItemSelectAsync';
import DataItemDatepicker from '../../../../../_common/components/DataItemDatepicker';
import {floatValueSign, integerValue} from '../../../../../../../utils';
import {existingReceiptDataSelectStyles} from '../../../../../_common/styles/reactSelectStyles';
import {currencyListOptions} from '../../../../../_common/constants/options';

const ReceiptData = ({
                       receiptType,
                       values,
                       checkboxValue,
                       findCustomerAction,
                       findAgentAction,
                       setFieldValue,
                     }) => {
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const intl = useIntl();
  const customerIDNumberLabel = intl.formatMessage({
    id: 'receipts-popup-existing-id',
    defaultMessage: 'ID',
  });
  const customerNameLabel = intl.formatMessage({
    id: 'receipts-popup-new-name',
    defaultMessage: 'Name',
  });
  const customerPhoneLabel = intl.formatMessage({
    id: 'receipts-popup-new-phone',
    defaultMessage: 'Phone',
  });
  const customerEmailLabel = intl.formatMessage({
    id: 'receipts-popup-new-email',
    defaultMessage: 'Email',
  });
  const customerCityLabel = intl.formatMessage({
    id: 'receipts-popup-new-city',
    defaultMessage: 'City',
  });
  const customerAddressLabel = intl.formatMessage({
    id: 'receipts-popup-new-address',
    defaultMessage: 'Address',
  });
  const exchangeRateLabel = intl.formatMessage({
    id: 'receipts-popup-exchange-rate',
    defaultMessage: 'Exchange rate',
  });
  const customerLabel = intl.formatMessage({
    id: 'receipts-popup-existing-customer',
    defaultMessage: 'Exchange rate',
  });
  const agentLabel = intl.formatMessage({
    id: 'receipts-popup-existing-agent',
    defaultMessage: 'Search agent',
  });
  const commentLabel = intl.formatMessage({
    id: 'receipts-popup-existing-comment',
    defaultMessage: 'Comment',
  });
  const clientHeader = intl.formatMessage({
    id: 'receipts-popup-subheader-client',
    defaultMessage: 'Client',
  });
  const invalidEmail = intl.formatMessage({
    id: 'invalid-email-message',
    defaultMessage: 'Invalid email',
  });
  const definitions = intl.formatMessage({
    id: 'receipts-popup-subheader-definitions',
    defaultMessage: 'Definitions',
  });
  const currencyLabel = intl.formatMessage({
    id: 'receipts-popup-currency',
    defaultMessage: 'Currency',
  });
  const dueDateLabel = intl.formatMessage({
    id: 'receipts-popup-new-chosenDate',
    defaultMessage: 'Date',
  });

  const regexMatch = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(values.customerEmail);

  const commonContainerStyle = 'mb-4 d-flex justify-content-between px-2';
  const commonSideLabelStyle = 'text-nowrap font-size-lg custom-brand-color';
  const commonInputContainerStyle = 'w-400px';

  return (
    <div className='d-flex justify-content-between'>
      <div className='w-50 px-9 border-right h-175px'>
        <div className='font-size-lg mb-4 custom-brand-color d-flex justify-content-center'>
          {clientHeader}
        </div>
        {receiptType === 'existing' &&
        <DataItemSelectAsync
          fieldId={'customer'}
          customStyles={existingReceiptDataSelectStyles}
          loadOptions={findCustomerAction}
          getOptionLabel={e => (`${e._id} - ${e.fullName}`)}
          getOptionValue={e => e._id}
          onChange={e => setFieldValue('customerEmail', e.email)}
          containerStyle={commonContainerStyle}
          sideLabelStyle={commonSideLabelStyle}
          inputContainerStyle={commonInputContainerStyle}
          sideLabel={
            <div className={'position-relative'}>
              <span className={'mandatoryMark'}>*</span>
              {customerLabel}
            </div>
          }
        />
        }
        {receiptType === 'new' &&
        <DataItem
          fieldId='customerName'
          containerStyle={commonContainerStyle}
          sideLabelStyle={commonSideLabelStyle}
          inputContainerStyle={commonInputContainerStyle}
          sideLabel={
            <div className={'position-relative'}>
              <span className={'mandatoryMark'}>*</span>
              {customerNameLabel}
            </div>
          }
        />
        }
        {receiptType === 'new' &&
        <DataItem
          fieldId='customerIdNumber'
          onChange={integerValue}
          containerStyle={commonContainerStyle}
          sideLabelStyle={commonSideLabelStyle}
          inputContainerStyle={commonInputContainerStyle}
          sideLabel={
            <div className={'position-relative'}>
              <span className={'mandatoryMark'}>*</span>
              {customerIDNumberLabel}
            </div>
          }
        />
        }
        {receiptType === 'new' &&
        <DataItem
          type={'tel'}
          fieldId='customerPhone'
          sideLabel={customerPhoneLabel}
          onChange={integerValue}
          containerStyle={commonContainerStyle}
          sideLabelStyle={commonSideLabelStyle}
          inputContainerStyle={commonInputContainerStyle}
        />
        }
        {receiptType === 'new' &&
        <>
          <div className='position-relative'>
            {(Boolean(!regexMatch && showErrorMessage && values.customerEmail)) ?
              (<div className='invalid-email-message'>{invalidEmail}</div>)
              : null
            }
            <DataItem
              type={'email'}
              fieldId='customerEmail'
              onBlur={() => {
                setShowErrorMessage(true)
              }}
              onFocus={() => {
                setShowErrorMessage(false)
              }}
              containerStyle={commonContainerStyle}
              sideLabelStyle={commonSideLabelStyle}
              inputContainerStyle={commonInputContainerStyle}
              sideLabel={
                <div className={'position-relative'}>
                  <span className={'mandatoryMark'}>*</span>
                  {customerEmailLabel}
                </div>
              }
            />
          </div>
        </>}
        {receiptType === 'new' &&
        <DataItem
          fieldId='customerCity'
          sideLabel={customerCityLabel}
          containerStyle={commonContainerStyle}
          sideLabelStyle={commonSideLabelStyle}
          inputContainerStyle={commonInputContainerStyle}
        />
        }
        {receiptType === 'new' &&
        <DataItem
          fieldId='customerAddress'
          sideLabel={customerAddressLabel}
          containerStyle={commonContainerStyle}
          sideLabelStyle={commonSideLabelStyle}
          inputContainerStyle={commonInputContainerStyle}
        />
        }
        {checkboxValue && receiptType === 'existing'
          ?
          null
          :
          <DataItemSelectAsync
            fieldId={'agentID'}
            customStyles={existingReceiptDataSelectStyles}
            loadOptions={findAgentAction}
            getOptionLabel={e => (`${e._id} - ${e.fullName}`)}
            getOptionValue={e => e._id}
            containerStyle={`mb-4 ${(!checkboxValue && receiptType === 'new') ? '' : 'mt-16'} d-flex justify-content-between px-2`}
            sideLabelStyle={'text-nowrap font-size-lg custom-brand-color'}
            inputContainerStyle={'w-400px'}
            sideLabel={
              <div className={'position-relative'}>
                <span className={'mandatoryMark'}>*</span>
                {agentLabel}
              </div>
            }
          />
        }
      </div>
      <div className={`w-50 px-9 border-left ${receiptType !== 'new' ? 'h-175px' : 'h-400px'}`}>
        <div className='font-size-lg mb-4 custom-brand-color d-flex justify-content-center'>
          {definitions}
        </div>
        <DataItemSelect
          fieldId={'currencyID'}
          options={currencyListOptions}
          customStyles={existingReceiptDataSelectStyles}
          containerStyle={commonContainerStyle}
          labelStyle={commonSideLabelStyle}
          inputContainerStyle={commonInputContainerStyle}
          label={
            <div className={'position-relative'}>
              <span className={'mandatoryMark'}>*</span>
              {currencyLabel}
            </div>
          }
        />
        <DataItem
          fieldId={'exchangeRate'}
          onChange={floatValueSign}
          containerStyle={commonContainerStyle}
          sideLabelStyle={commonSideLabelStyle}
          inputContainerStyle={commonInputContainerStyle}
          sideLabel={
            <div className={'position-relative'}>
              <span className={'mandatoryMark'}>*</span>
              {exchangeRateLabel}
            </div>
          }
        />
        {receiptType === "existing" && (
          <DataItem
            fieldId={'comment'}
            sideLabel={commentLabel}
            containerStyle={commonContainerStyle}
            sideLabelStyle={commonSideLabelStyle}
            inputContainerStyle={commonInputContainerStyle}
          />
        )}
        {receiptType === "new" && (
          <DataItemDatepicker
            fieldId={'dueDate'}
            containerStyle={'mb-4 d-flex justify-content-between pl-2 w-275px mt-14'}
            sideLabelStyle={commonSideLabelStyle}
            inputContainerStyle={'w-200px'}
            sideLabel={
              <div className={'position-relative mr-4'}>
                <span className={'mandatoryMark'}>*</span>
                {dueDateLabel}
              </div>
            }
          />
        )}
      </div>
    </div>
  );
};

ReceiptData.propTypes = {
  receiptType: PropTypes.string
};

export default ReceiptData;
